import { useEffect, useState } from "react";
import Divider from "@mui/material/Divider";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import IconButton from "@mui/material/IconButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AddLinkOutlinedIcon from "@mui/icons-material/AddLinkOutlined";
import LinkOffOutlinedIcon from "@mui/icons-material/LinkOffOutlined";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";

import CancelIcon from "@mui/icons-material/Cancel";
import EditNoteIcon from "@mui/icons-material/Edit";
import SpellcheckIcon from "@mui/icons-material/Spellcheck";
import { config } from "../../../../services/config";
import { StyledMenu } from "../../../ui/components/StyledMenu";
import {
  useAttachRemitoMutation,
  useDeleteAttachedRemitoMutation,
  useAttachPresupuestoMutation,
  useDeleteAttachedPresupuestoMutation,
} from "../../../api/restApiSlice";
import { useNotification } from "../../../notifications";

export function AdminOrderActions({
  order,
  aproveOrder,
  addComment,
  billOrder,
  receiptOrder,
  showDeliver,
  showDeliveryDelete,
  showCancel,
  showGuide,
  showFinish,
  markPayed,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { pending, processing, canceled, finished } = {
    ...config.orderStatus,
  };
  const { displayNotification } = useNotification();
  const [
    attachRemito,
    { isLoading: isAttaching, isSuccess: isAttachOk, isError: isAttachError },
  ] = useAttachRemitoMutation();

  const [
    deleteAttachedRemito,
    { isLoading: isDeleting, isSuccess: isDeleteOk, isError: isDeleteError },
  ] = useDeleteAttachedRemitoMutation();

  const [
    attachPresupuesto,
    {
      isLoading: isAttachingPres,
      isSuccess: isAttachPresOk,
      isError: isAttachPresError,
    },
  ] = useAttachPresupuestoMutation();

  const [
    deleteAttachedPresupuesto,
    {
      isLoading: isDeletingPres,
      isSuccess: isDeletePresOk,
      isError: isDeletePresError,
    },
  ] = useDeleteAttachedPresupuestoMutation();

  useEffect(() => {
    isAttachOk &&
      displayNotification({
        message: "El Remito se adjuntó con exito.",
        type: "success",
      });
    isDeleteOk &&
      displayNotification({
        message: "El Remito adjunto se eliminó con éxito.",
        type: "success",
      });

    //dispatch({ type: ACTIONS.HIDE });
  }, [isAttachOk, isDeleteOk]);

  useEffect(() => {
    isAttachError &&
      displayNotification({
        message: "No se pudo adjuntar el Remito.",
        type: "error",
      });
    isAttachError &&
      displayNotification({
        message: "No se pudo eliminar el Remito adjunto.",
        type: "error",
      });
  }, [isAttachError, isDeleteError]);

  useEffect(() => {
    isAttachError &&
      displayNotification({
        message: "No se pudo adjuntar el Presupuesto.",
        type: "error",
      });
    isAttachError &&
      displayNotification({
        message: "No se pudo eliminar el Presupuesto adjunto.",
        type: "error",
      });
  }, [isAttachPresError, isDeletePresError]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCancel = () => {
    handleClose();
    showCancel(order.ordenContabilium);
  };

  const handleDelivery = () => {
    handleClose();
    showDeliver(order.id);
  };

  const handleDeliveryDelete = () => {
    handleClose();
    showDeliveryDelete(order.id);
  };

  const handleDeliveryAttachDelete = () => {
    handleClose();
    deleteAttachedRemito({ id: order.id });
  };

  const handlePresupuestoAttachDelete = () => {
    handleClose();
    deleteAttachedPresupuesto({ id: order.id });
  };
  function selectFile(event) {
    const input = event.target;
    if (!input.files || input.files.length === 0) {
      return;
    }
    const id = input.id;
    const file = input.files[0];
    const data = new FormData();
    data.append("file", file);
    attachRemito({ id, data });
    handleClose();
  }
  function selectPresFile(event) {
    const input = event.target;
    if (!input.files || input.files.length === 0) {
      return;
    }
    const id = input.id;
    const file = input.files[0];
    const data = new FormData();
    data.append("file", file);
    attachPresupuesto({ id, data });
    handleClose();
  }

  const handleApprove = () => {
    handleClose();
    aproveOrder(order.ordenContabilium);
  };

  const handleBilling = () => {
    handleClose();
    billOrder();
  };

  const handleReceipt = () => {
    handleClose();
    receiptOrder();
  };

  const canCancel = () => {
    return order.estado !== finished && order.comprobanteContabilium == null;
  };

  const handleSetGuideNumber = () => {
    handleClose();
    showGuide(order.id);
  };

  const handleFinish = () => {
    handleClose();
    showFinish(order.ordenContabilium);
  };

  function handlePayed() {
    handleClose();
    markPayed(order.id);
  }
  function handleNewComment() {
    handleClose();
    addComment(order.id);
  }

  return (
    <>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={(evnt) => setAnchorEl(evnt.currentTarget)}
      >
        <MoreVertIcon />
      </IconButton>
      <StyledMenu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {/**
         * APROBAR
         */}
        <MenuItem
          key="aprobar"
          onClick={handleApprove}
          disabled={order.estado !== 0}
        >
          <ListItemIcon>
            <SpellcheckIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Aprobar</ListItemText>
        </MenuItem>

        {/**
         * CANCELAR
         */}
        <MenuItem key="cancelar" onClick={handleCancel} disabled={!canCancel()}>
          <ListItemIcon>
            <CancelIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Cancelar</ListItemText>
        </MenuItem>

        {/**
         * FINALIZAR
         */}
        <MenuItem
          key="finalizar"
          onClick={handleFinish}
          disabled={order.estado === processing}
        >
          <ListItemIcon>
            <DoneAllIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Finalizar</ListItemText>
        </MenuItem>

        {/**
         * INICAR CONVERSACION
         */}
        <MenuItem key="comentarios" onClick={handleNewComment}>
          <ListItemIcon>
            <EditNoteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Comentar...</ListItemText>
        </MenuItem>

        <Divider />

        {/**
         * RECIBO
         */}
        <MenuItem key="recibo" onClick={handleReceipt} disabled={!canCancel}>
          <ListItemIcon>
            <AddCircleOutlineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Recibo</ListItemText>
        </MenuItem>

        {/**
         * FACTURAR
         */}
        <MenuItem
          key="facturar"
          onClick={handleBilling}
          disabled={
            order.comprobanteContabilium !== null ||
            order.estado === canceled ||
            order.estado === finished ||
            order.estado === pending
          }
        >
          <ListItemIcon>
            <AddCircleOutlineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>
            {"Factura" +
              (order.condicionVenta === config.condicionVtaBiocook
                ? " (en Biocook)"
                : "")}
          </ListItemText>
        </MenuItem>

        {/**
         * PAGADO
         */}
        <MenuItem
          key="pagado"
          onClick={handlePayed}
          disabled={order.pagado !== 0}
        >
          <ListItemIcon>
            <AddCircleOutlineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Pagado</ListItemText>
        </MenuItem>

        <Divider />

        {/**
         * REMITO
         */}
        <MenuItem
          key="remitir"
          onClick={handleDelivery}
          disabled={order.deliveries.length > 0 || order.pagado === 0}
        >
          <ListItemIcon>
            <AddCircleOutlineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Generar Remito</ListItemText>
        </MenuItem>

        <MenuItem
          key="eliminar-remito"
          onClick={handleDeliveryDelete}
          disabled={order.deliveries.length === 0 && order.estado !== finished}
        >
          <ListItemIcon>
            <HighlightOffOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Eliminar Remito</ListItemText>
        </MenuItem>

        <Divider />
        {/**
         * REMITO Adjunto
         */}
        <MenuItem
          key="adjuntar-remito"
          disabled={order.remitoAdjunto || order.pagado === 0}
          component="label"
        >
          <ListItemIcon>
            <AddLinkOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Adjuntar Remito</ListItemText>
          <input
            id={order.id}
            type="file"
            hidden
            accept=".pdf"
            onChange={selectFile}
          />
        </MenuItem>

        <MenuItem
          key="eliminar-remito-adjunto"
          onClick={handleDeliveryAttachDelete}
          disabled={!order.remitoAdjunto && order.estado !== finished}
        >
          <ListItemIcon>
            <LinkOffOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Eliminar Adjunto</ListItemText>
        </MenuItem>

        <Divider />

        {/**
         * Presupuesto Adjunto
         */}
        <MenuItem
          key="adjuntar-presupuesto"
          disabled={
            order.presupuestoAdjunto ||
            order.estado === canceled ||
            order.estado === finished
          }
          component="label"
        >
          <ListItemIcon>
            <AddLinkOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Adjuntar Presupuesto</ListItemText>
          <input
            id={order.id}
            type="file"
            hidden
            accept=".pdf"
            onChange={selectPresFile}
          />
        </MenuItem>

        <MenuItem
          key="eliminar-presupuesto-adjunto"
          onClick={handlePresupuestoAttachDelete}
          disabled={
            !order.presupuestoAdjunto &&
            (order.estado !== canceled || order.estado !== finished)
          }
        >
          <ListItemIcon>
            <LinkOffOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Eliminar Presupuesto</ListItemText>
        </MenuItem>

        <Divider />

        {/**
         * GUIA
         */}
        <MenuItem
          key="guia"
          onClick={handleSetGuideNumber}
          disabled={
            order.deliveries.length === 0 ||
            order.estado === canceled ||
            order.estado === finished ||
            order.estado === pending
          }
        >
          <ListItemIcon>
            <AddCircleOutlineIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText># Guia</ListItemText>
        </MenuItem>
      </StyledMenu>
    </>
  );
}
